<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">

      <div class="text-center mb-4 mt-6 pt-5">
        <h1 class="mat-display-1 fw-bold" style="color: #215DAB">Gift Certificate Balance</h1>
        <p class="mat-subheading-2 text-secondary">Enter your certificate code to check its balance</p>
      </div>

      <mat-card class="p-4 shadow-lg rounded" style="background-color: #f8faff;">
        <mat-card-content>
          <mat-progress-spinner class="mx-auto my-3" *ngIf="pending" mode="indeterminate" diameter="40">
          </mat-progress-spinner>

          <form (ngSubmit)="checkBalance()">
            <div class="mb-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Certificate code</mat-label>
                <input matInput
                  name="code"
                  [(ngModel)]="code"
                  autocomplete="off"
                  autocapitalize="characters"
                  placeholder="e.g. 8ZDAE5N2">
              </mat-form-field>
            </div>

            <button mat-raised-button color="primary" class="w-100" type="submit"
              [disabled]="pending || !code.trim()">
              Check Balance
            </button>
          </form>

          <div class="mt-4" *ngIf="result">
            <ng-container *ngIf="result.found; else notFound">
              <div class="text-center">
                <p class="text-secondary mb-1">Remaining balance</p>
                <h2 class="fw-bold mb-3">{{ result.remaining_balance }}</h2>
                <p class="mb-1"><strong>Status:</strong> {{ result.status }}</p>
                <p class="mb-0" *ngIf="result.expiration_date">
                  <strong>Expires:</strong> {{ result.expiration_date | date: 'MM/dd/yyyy' }}
                </p>
              </div>
            </ng-container>
            <ng-template #notFound>
              <p class="text-danger text-center mb-0">
                {{ result.error || 'No gift certificate was found for that code. Please check the code and try again, or contact your studio.' }}
              </p>
            </ng-template>
          </div>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</div>
